import { render, staticRenderFns } from "./DisplayPreview.vue?vue&type=template&id=2875e542&scoped=true&lang=html&"
import script from "./DisplayPreview.vue?vue&type=script&lang=js&"
export * from "./DisplayPreview.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPreview.vue?vue&type=style&index=0&id=2875e542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2875e542",
  null
  
)

export default component.exports